import { Box } from '@mui/material';
import FieldSalesPerformanceAnalysis from './FieldSalesPerformanceAnalysis.jsx';
import { periodLabel } from './fieldSalesFormat.js';

/**
 * Field Sales — Overview tab. Now holds ONLY the "{Mon} — Target Achievement &
 * YoY Growth" section (dimension pills, four blue cards, the breakdown table).
 * The KPI cards and Auto Insights were moved up to page level so they stay
 * visible on every tab.
 *
 * @param {{ summary: object }} props  mapped getSummary data (used for the {Mon} token)
 */
export default function FieldSalesOverviewTab({ summary }) {
  const pl = periodLabel(summary?.months);
  return (
    <Box sx={{ pt: 1 }}>
      <FieldSalesPerformanceAnalysis pl={pl} />
    </Box>
  );
}
